import React from 'react';
import { IconButton, Tooltip, useTheme as useMuiTheme } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * 主题切换按钮组件
 * 允许用户在暗色模式和亮色模式之间切换
 */
const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useTheme();
  const muiTheme = useMuiTheme();

  return (
    <Tooltip title={mode === 'light' ? '切换为暗色模式' : '切换为亮色模式'}>
      <IconButton 
        onClick={toggleTheme} 
        color="inherit"
        sx={{ 
          ml: 1,
          transition: 'all 0.3s',
          '&:hover': {
            backgroundColor: mode === 'light' 
              ? 'rgba(0, 0, 0, 0.08)' 
              : 'rgba(255, 255, 255, 0.08)',
            transform: 'scale(1.1)',
          },
        }}
      >
        {mode === 'light' ? (
          <Brightness4Icon sx={{ fontSize: 24 }} />
        ) : (
          <Brightness7Icon sx={{ fontSize: 24, color: muiTheme.palette.primary.light }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
